import * as React from 'react';

const Company = (props: React.SVGProps<SVGSVGElement>) => (
    <svg width={10} height={10} fill="none" {...props}>
        <g fill="currentColor" clipPath="url(#company_a)">
            <path d="M9.059.617A.79.79 0 0 0 8.371.25H1.629a.79.79 0 0 0-.688.367L.094 2.434A1 1 0 0 0 0 2.857v.268A1.193 1.193 0 0 0 1.25 4.25 1.193 1.193 0 0 0 2.5 3.125 1.193 1.193 0 0 0 3.75 4.25 1.193 1.193 0 0 0 5 3.125 1.193 1.193 0 0 0 6.25 4.25 1.193 1.193 0 0 0 7.5 3.125 1.193 1.193 0 0 0 8.75 4.25 1.193 1.193 0 0 0 10 3.125v-.268a1 1 0 0 0-.094-.423zM8.75 5.25a2.33 2.33 0 0 1-1.25-.358 2.42 2.42 0 0 1-2.5 0 2.36 2.36 0 0 1-2.5 0c-.374.236-.808.36-1.25.358-.255 0-.508-.04-.75-.122V8.75a1 1 0 0 0 1 1h4a.5.5 0 0 0 .5-.5v-2a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1.755A.75.75 0 1 0 9.5 9V5.128a2.4 2.4 0 0 1-.75.122M4.5 7.75a.5.5 0 0 1-.5.5H2.5a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5H4a.5.5 0 0 1 .5.5z" />
        </g>
        <defs>
            <clipPath id="company_a">
                <path fill="#fff" d="M0 0h10v10H0z" />
            </clipPath>
        </defs>
    </svg>
);
export default Company;
